import { render, staticRenderFns } from "./DocEdit.vue?vue&type=template&id=4b4707d2&scoped=true"
import script from "./DocEdit.vue?vue&type=script&lang=js"
export * from "./DocEdit.vue?vue&type=script&lang=js"
import style0 from "./DocEdit.vue?vue&type=style&index=0&id=4b4707d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4707d2",
  null
  
)

export default component.exports